module.exports = __webpack_public_path__ + "img/trustpilot.957d33aa.svg";